var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronLeftCarouselSharedCh = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 16,
  viewBox: "0 0 10 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.94006 14.12L3.83339 8L9.94006 1.88L8.06006 0L0.0600586 8L8.06006 16L9.94006 14.12Z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNOS45NDAwNiAxNC4xMkwzLjgzMzM5IDhMOS45NDAwNiAxLjg4TDguMDYwMDYgMEwwLjA2MDA1ODYgOEw4LjA2MDA2IDE2TDkuOTQwMDYgMTQuMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4NCjwvc3ZnPg0K";
export { SvgChevronLeftCarouselSharedCh as ReactComponent };